// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._UvaHK6fukmTc4 {
  overflow: visible;
}
._UvaHK6fukmTc4.sfCjcMKVjES0Hl {
  width: 640px;
  margin: var(--ds-space-0, 0) auto;
  transition: width 0.3s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  ._UvaHK6fukmTc4.sfCjcMKVjES0Hl {
    transition: none;
  }
}
._UvaHK6fukmTc4.sfCjcMKVjES0Hl.t_6PqKcL7DA8Qa {
  width: 1084px;
}
@media only screen and (min-width: 601px) and (max-width: 1099px) {
  ._UvaHK6fukmTc4.sfCjcMKVjES0Hl.t_6PqKcL7DA8Qa {
    width: calc(100vw - var(--ds-space-200, 16px));
  }
}
@media only screen and (max-width: 600px) {
  ._UvaHK6fukmTc4.sfCjcMKVjES0Hl,
  ._UvaHK6fukmTc4.sfCjcMKVjES0Hl.t_6PqKcL7DA8Qa {
    width: calc(100vw - var(--ds-space-200, 16px));
    margin: var(--ds-space-400, 32px) var(--ds-space-100, 8px) var(--ds-space-0, 0);
  }
}
@media only screen and (max-width: 750px) {
  ._UvaHK6fukmTc4 > div {
    /* stylelint-disable-next-line declaration-no-important */
    margin: var(--ds-space-0, 0) !important;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardBackDialog": `_UvaHK6fukmTc4`,
	"cardBackRedesign": `sfCjcMKVjES0Hl`,
	"withPanel": `t_6PqKcL7DA8Qa`
};
export default ___CSS_LOADER_EXPORT___;
